import React from 'react';
import './Location.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const Location = () => {
  const { t } = useLanguage();
  const distances = [
    { from: t('location.distanceItems.pune.from'), dist: t('location.distanceItems.pune.distance'), time: t('location.distanceItems.pune.time') },
    { from: t('location.distanceItems.saswad.from'), dist: t('location.distanceItems.saswad.distance'), time: t('location.distanceItems.saswad.time') },
    { from: t('location.distanceItems.jejuri.from'), dist: t('location.distanceItems.jejuri.distance'), time: t('location.distanceItems.jejuri.time') },
    { from: t('location.distanceItems.purandarFort.from'), dist: t('location.distanceItems.purandarFort.distance'), time: t('location.distanceItems.purandarFort.time') }
  ];

  const pilgrimPlaces = [
    { key: 'saswad', image: '/Assets/home/sopankaka madir saswad.jpeg' },
    { key: 'narayanpur', image: '/Assets/home/Narayannpur temple.jpeg' },
    { key: 'bopgav', image: '/Assets/home/balaji temple (1).jpeg' },
    { key: 'ketkavale', image: '/Assets/home/kanifnath temple.jpeg' },
    { key: 'jejuri', image: '/Assets/home/khandoba mandir jejuri (1).jpeg' },
    { key: 'chaturmukha', image: '/Assets/home/chaturmukh temple.jpeg' },
    { key: 'bhuleshwar', image: '/Assets/home/bhuleshwar temple.jpeg' },
    { key: 'pandeshwar', image: '/Assets/home/pandeshwar temple.jpeg' }
  ];

  const pilgrimGalleryItems = [...pilgrimPlaces, ...pilgrimPlaces];

  return (
    <div className="location-page">
      <section className="location-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>{t('templeTitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <div className="container">

        <section className="distance-section">
          <h2 className="section-title">{t('location.distanceTitle')}</h2>
          <div className="divider"></div>

          <div className="distance-grid">
            {distances.map((item, index) => (
              <div key={index} className="distance-card">
                <div className="distance-icon"><Icon name="location" /></div>
                <h3 className="notranslate"><span translate="no" className="notranslate">{item.from}</span></h3>
                <div className="distance-details">
                  <span className="distance-value" translate="no" lang="mr">{item.dist}</span>
                  <span className="time-value"><Icon name="clock" /> {item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="travel-options-section">
          <h2 className="section-title">{t('location.travelOptionsTitle')}</h2>
          <div className="divider"></div>

          <div className="travel-grid">
            <div className="travel-card">
              <div className="travel-icon"><Icon name="train" /></div>
              <h3>{t('location.travelCards.train.title')}</h3>
              <div className="travel-details">
                <p><strong>{t('location.travelCards.train.nearestStation')}</strong></p>
                <p><strong>{t('location.travelCards.train.distanceFromStation')}</strong></p>
                <p><strong>{t('location.travelCards.train.travelTime')}</strong></p>
                <p className="travel-note">
                  {t('location.travelCards.train.details')}
                </p>
              </div>
            </div>

            <div className="travel-card">
              <div className="travel-icon"><Icon name="bus" /></div>
              <h3>{t('location.travelCards.bus.title')}</h3>
              <div className="travel-details">
                <p><strong>{t('location.travelCards.bus.nearestBusStand')}</strong></p>
                <p><strong>{t('location.travelCards.bus.msrtcAvailability')}</strong></p>
                <p><strong>{t('location.travelCards.bus.distanceAndTime')}</strong></p>
                <p className="travel-note">
                  {t('location.travelCards.bus.details')}
                </p>
              </div>
            </div>

            <div className="travel-card">
              <div className="travel-icon"><Icon name="car" /></div>
              <h3>{t('location.travelCards.car.title')}</h3>
              <div className="travel-details">
                <p><strong>{t('location.travelCards.car.fromPune')}</strong></p>
                <p><strong>{t('location.travelCards.car.distance')}</strong></p>
                <p><strong>{t('location.travelCards.car.travelTime')}</strong></p>
                <p className="travel-note">
                  {t('location.travelCards.car.details')}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="pilgrimage-section" id="pilgrimage">
          <h2 className="section-title">{t('pageContent.pilgrimPlaces')}</h2>
          <div className="divider"></div>
          <div className="places-gallery-shell visible">
            <div className="places-gallery-track">
              {pilgrimGalleryItems.map((place, index) => (
                <article key={`${place.key}-${index}`} className="place-gallery-card">
                  <div className="place-gallery-image">
                    <img src={place.image} alt={t(`pageContent.${place.key}`)} loading="lazy" />
                  </div>
                  <h3 className="notranslate"><span translate="no" className="notranslate">{t(`pageContent.${place.key}`)}</span></h3>
                  <p>{t(`pageContent.${place.key}Desc`)}</p>
                  <span className="distance" translate="no">{t('pageContent.distanceValue.' + place.key)}</span>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="map-section">
          <div className="map-container">
            <iframe
              title="मंदिर स्थान"
              src="https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
          <p className="map-note">{t('location.mapNote')}</p>
        </section>


        <section className="directions-section">
          <div className="directions-box">
            <h3>{t('location.directionsTitle')}</h3>
            <p>
              {t('location.directionsText')}
            </p>
            <div className="directions-buttons">
              <button className="direction-btn">
                <Icon name="map" /> {t('location.getDirectionsBtn')}
              </button>
              <button className="direction-btn secondary">
                <Icon name="phone" /> {t('location.callAssistance')}
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Location;



